export const listItem = {
	group: "listItem",
	content: "block+",
	defining: true,
	attrs: {
		isTaskItem: { default: null },
	},
};
